import * as React from 'react';
import type {
  RevertPrioritizedProductsPayload,
} from 'contracts/prioritized-products';
import { api } from 'services/api';

export const useRevertPrioritizedProducts = () => {
  const revertPrioritizedProducts = React.useCallback(async (payload: RevertPrioritizedProductsPayload) => {
    await api.post('/inventory/prioritized-products/revert', payload);
  }, []);

  return {
    revertPrioritizedProducts,
  };
};